import { render, staticRenderFns } from "./DocumentEditNameDialog.vue?vue&type=template&id=57196b01"
import script from "./DocumentEditNameDialog.vue?vue&type=script&lang=js"
export * from "./DocumentEditNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports